<div
  *ngIf="{ steps: stepperSubject | async } as data"
  fxLayout="column"
  class="panel-background-color panel-position"
  fxHide.xs
  fxHide.lt-md>
  <mat-expansion-panel class="expansion-panel p-20 pointer-events-none" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title class="panel-title-width">
        <div>
          <span class="fs-18px">{{ stepperTitle }}</span>
        </div>
      </mat-panel-title>
      <mat-panel-description> </mat-panel-description>
    </mat-expansion-panel-header>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngFor="let step of data.steps; let i = index"
    [expanded]="isStepExpanded(step, i)"
    [ngClass]="isStepExpanded(step, i) ? 'expandend-bg-color' : ''"
    class="expansion-panel p-20"
    hideToggle
    [disabled]="isExnapsionPanelDisabled(step, i)">
    <mat-expansion-panel-header [style.paddingBottom]="getStepDescOffsetPx(step.stepDescription)">
      <mat-panel-title class="panel-title-width">
        <div fxLayout="column">
          <span>{{ step.stepTitle }}</span>
          <span class="step-description" [style.marginBottom]="getStepDescOffsetPx(step.stepDescription)">{{
            step.stepDescription
          }}</span>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-stepper
      [selectedIndex]="currentActiveSubstepIndex(step)"
      orientation="vertical"
      class="expandend-bg-color"
      #stepper>
      <ng-template matStepperIcon="edit">
        <span class="material-symbols-outlined"> check_circle </span>
      </ng-template>
      <ng-template matStepperIcon="number">
        <span class="material-symbols-outlined"> adjust </span>
      </ng-template>

      <mat-step *ngFor="let subStep of step.subSteps" [completed]="subStep.isCompleted">
        <ng-template matStepLabel>{{ subStep.subStep }}</ng-template>
      </mat-step>
    </mat-stepper>
  </mat-expansion-panel>
</div>
